import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";

import Paths from "./paths";
import { PAMachineGroup } from "./types";

export const paMachineGroupListService = (params: {
  keyword?: string | null;
  code?: string | null;
  name?: string | null;
  page?: number | null;
  limit?: number | null;
  status?: number | null;
}) =>
  RestAPIClient.call<RestAPIResponseList<PAMachineGroup>>({
    method: HTTPRequestMethods.GET,
    url: Paths.List,
    config: {
      requireAuthentication: true,
      params,
    },
  });

export const paMachineGroupListShortService = (params: {
  keyword?: string | null;
  code?: string | null;
  name?: string | null;
  page?: number | null;
  limit?: number | null;
  status?: number | null;
}) =>
  RestAPIClient.call<RestAPIResponseList<PAMachineGroup>>({
    method: HTTPRequestMethods.GET,
    url: Paths.Short,
    config: {
      requireAuthentication: true,
      params,
    },
  });

export const paMachineGroupCreateService = (params: {
  code: string;
  name: string;
  nativeName: string;
  description: string;
  nativeDescription: string;
}) =>
  RestAPIClient.call<PAMachineGroup>({
    method: HTTPRequestMethods.POST,
    url: Paths.Create,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });

export const paMachineGroupUpdateService = ({
  id,
  ...rest
}: Parameters<typeof paMachineGroupCreateService>[0] & {
  id: string;
  status?: number;
}) =>
  RestAPIClient.call<PAMachineGroup>({
    method: HTTPRequestMethods.PUT,
    url: `${Paths.Update}/${String(id)}`,
    config: {
      requireAuthentication: true,
    },
    data: rest,
  });

export const paMachineGroupDetailService = (id: string) =>
  RestAPIClient.call<PAMachineGroup>({
    method: HTTPRequestMethods.GET,
    url: `${Paths.Detail}/${id}`,
    config: {
      requireAuthentication: true,
    },
  });

export const paMachineGroupDeleteService = (id: string) =>
  RestAPIClient.call<PAMachineGroup>({
    method: HTTPRequestMethods.DELETE,
    url: `${Paths.Delete}/${id}`,
    config: {
      requireAuthentication: true,
    },
  });
